import { AbstractEntityMapper } from '@pf/shared-services';
import {
    AuditCreate,
    AuditDto,
    AuditRead,
    AuditSearchParams,
} from '../../entities/audit.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { AuditMetadataMap } from './audit.mapping-profile';

@Injectable()
export class AuditMapper extends AbstractEntityMapper<
    AuditRead,
    AuditCreate,
    AuditDto,
    AuditSearchParams
> {
    constructor() {
        super(AuditDto, PlatformWmsMapper, AuditMetadataMap.symbols);
    }
}
